module.exports = __webpack_public_path__ + "img/Uk.27fd49f1.svg";